

WB.Modules = WB.Modules || {};
WB.Modules.ForecastsDirectiveLink = function (_Config) {
    return function (scope, element, attr) {

        scope.navEnabled = function ()
        {
            var enabled = true;

            if (scope.$root.App.PlatformCode !== undefined)
            {
                const platform       = _Config.Platform || {};
                const platformConfig = platform[scope.$root.App.PlatformCode] || {};
                const configValue    = platformConfig.Navigation;
                enabled              = typeof configValue === typeof false
                                     ? configValue
                                     : enabled;
            }

            return enabled;
        };
    };
};

WB.Modules.ForecastsDirectiveCtrl = function($scope) {

    this.clearError = function() {
        $scope.error = false;
    };

    this.error = function(err) {
        $scope.error = true;
    };

};
WB.Modules.ForecastsDirectiveCtrl.$inject = ['$scope'];

WB.Modules.ForecastsDirective = function (_Config) {
    return {
        scope: {
            location: '='
        },
        restrict: 'AE',
        link: WB.Modules.ForecastsDirectiveLink(_Config),
        controller: WB.Modules.ForecastsDirectiveCtrl,
        template: `<div class="forecasts">
        <div class="page-subnav-container">
            <div class="container" ng-if="navEnabled()">
                <forecast-navigation />
            </div>
        </div>

        <div class="forecasts-tab">
            <div ng-if="$root.ActiveRoute.locals.name == 'forecasts'">
                <div
                wb-module-forecasts-current
                location="location"
                loading="$parent.loading"></div>
            </div>
            <div ng-if="$root.ActiveRoute.locals.name == 'forecasts.10-day-weather'">
                <daily-forecast-wrapper />
            </div>
            <div ng-if="$root.ActiveRoute.locals.name == 'forecasts.hourly'">
                <hourly-forecast-wrapper />
            </div>
        </div>

        <div class="module-loader block-loader is-clear"
            wb-preloader color="white"
            ng-if="$root.RouteLoader === 'Forecast'"
            ng-cloak>
        </div>

        <div class="module-error is-large"
            ng-if="error" ng-cloak>
            <div class="module-error__box">
                <span class="icon">
                    <svg>
                        <use xlink:href="/dist/img/ui/cloud-error.svg"></use>
                    </svg>
                </span>
                <div class="message">
                    Weather Data Not Available
                </div>
            </div>
        </div>

    </div>
    `
    };
};
WB.Modules.ForecastsDirective.$inject = ['_Config'];

WB.App.directive('wbModuleForecasts', WB.Modules.ForecastsDirective);
